export enum AuthenticationTypes {
    Bizagi,
    Custom,
    Federated,
    Ldap,
    Mixed,
    OAuth2,
    Windows,
    Multiple
};

export enum EMultipleAuthViewMode {
    Add,
    Edit,
    Unselect
}


export enum ErrorMessages {
  WithoutMultipleMethodTag,
  WithoutAuthenticatorsTag,
  AuthenticatorWithoutTypeTag,
  AuthenticatorWithoutSubtypeTag,
  AuthenticatorInvalidTypeOrSubtype,
  AuthenticatorWithoutEnabledTag,
  AuthenticatorWithoutDisplayNameTag,
  AuthenticatorWithoutOptionsTag,
  AuthenticatorWithoutOauthOptionsTag,
  AuthenticatorWithoutDomains,
  DomainsRepeatedName,
  DomainsRepeatedDisplayName,
  DomainNameEmpty,
  DomainDisplayNameEmpty,
}
